(ns storrito.matomo.core)

(defn fire-event!
  [{:keys [category action name value]}]
  (try
    ;; Docs: https://matomo.org/docs/event-tracking/
    (js/window._paq.push
      #js ["trackEvent"
           category
           action
           name
           value])
    (catch js/Error e
      (js/console.warn "Could not fire matomo event - not defined (on development? adblocker?)"))))

(defn fire-account-registered-event!
  [name]
  (fire-event! {:category "authentication"
                :action "registered"
                :name name}))

(comment
  (fire-event! {:category "test"
                :action "test action"
                :name "test name"
                :value 1337})
  )